var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-icon", {
        staticClass: "trigger",
        staticStyle: {
          "font-size": "17px",
          "padding-right": "10px",
          cursor: "pointer"
        },
        attrs: { type: _vm.collapsed ? "menu-unfold" : "menu-fold" },
        on: { click: _vm.siderBarOpen }
      }),
      _c(
        "a-breadcrumb",
        { staticClass: "breadcrumb", staticStyle: { display: "inline-block" } },
        _vm._l(_vm.breadList, function(item) {
          return _c(
            "a-breadcrumb-item",
            { key: item.name },
            [
              _c(
                "router-link",
                { attrs: { to: { path: item.path === "" ? "/" : item.path } } },
                [
                  item.meta.icon
                    ? _c("a-icon", { attrs: { type: item.meta.icon } })
                    : _vm._e(),
                  _vm._v(" " + _vm._s(item.meta.title) + " ")
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }